import React from 'react'
import { Trans, useTranslation } from 'next-i18next'
import {
  Box,
  Button,
  IconArrowUpRight,
  Inline,
  Stack,
  Text
} from '@machobear/design-system'

import { useTermsDialogContext } from '@/components/terms-dialog/context'

const TermsRequiredCard = ({
  externalInfo
}: {
  externalInfo: { source_info_name: string }
  width?: string
}) => {
  const { t } = useTranslation()
  const { showModalForRequiredTerms } = useTermsDialogContext()

  const source = externalInfo?.source_info_name

  return (
    <>
      <Box
        paddingX="large"
        paddingY="xlarge"
        background="white"
        borderRadius="xlarge"
        boxShadow="borderNeutralLight"
        width="full"
      >
        <Stack space="gutter" align="left">
          <Text size="xlarge" weight="strong" align="center">
            {t('b.listing.terms.required.card.title', 'Terms Required')}
          </Text>
          <Text size="medium" tone="secondary">
            <Trans
              i18nKey="b.listing.login.required.card.description"
              values={{ source }}
            >
              This listing contains information provided by {{ source }}
            </Trans>
            {t(
              'b.listing.terms.required.card.description.2',
              `Please accept the terms to continue.`
            )}
          </Text>

          <Inline space="none" align="center">
            <Button
              icon={<IconArrowUpRight />}
              id="listing_details_mls_termsrequired_taptoview_click"
              onClick={() =>
                showModalForRequiredTerms('trreb_agreements', () => {})
              }
              variant="ghost"
            >
              {t('b.listing.terms.required.card.button.text', 'Tap to view')}
            </Button>
          </Inline>
        </Stack>
      </Box>
    </>
  )
}

export default TermsRequiredCard
